module.exports = __webpack_public_path__ + "img/2344483.fd81dab4.png";